import { Chip, ChipProps } from '@mui/material';

import useLocales from 'src/hooks/useLocales';

import { WorkflowInstanceStatus } from 'src/@types/workflow/types';

type InstanceStatus = {
  labelKey: string;
  color: 'info' | 'success' | 'error' | 'default';
};

export const INSTANCE_STATUSES: Record<WorkflowInstanceStatus, InstanceStatus> = {
  [WorkflowInstanceStatus.InProgress]: { labelKey: 'workflows.status.inProgress', color: 'info' },
  [WorkflowInstanceStatus.Completed]: { labelKey: 'workflows.status.completed', color: 'success' },
  [WorkflowInstanceStatus.Rejected]: { labelKey: 'workflows.status.rejected', color: 'error' },
  [WorkflowInstanceStatus.Cancelled]: { labelKey: 'workflows.status.cancelled', color: 'default' },
};

type WorkflowStatusLabelProps = Omit<ChipProps, 'color' | 'label'> & {
  status: WorkflowInstanceStatus;
};

export function WorkflowStatusLabel({ status, ...rest }: WorkflowStatusLabelProps) {
  const { t } = useLocales();

  const { labelKey, color } = INSTANCE_STATUSES[status];

  return <Chip size="small" color={color} label={t(labelKey)} {...rest} />;
}
